// Placement identifiers from Rokt's integration guide PDF; see CN-47520

const IS_PROD = process.env.REACT_APP_DEPLOY_ENV === 'prod';

type RoktAdsPlatform = 'direct' | 'marketplace' | 'obn';

const ROKT_CHECKOUT_IDENTIFIERS: Record<RoktAdsPlatform, string> = IS_PROD
  ? {
      direct: 'direct_checkout',
      marketplace: 'marketplace_checkout',
      obn: 'obn_checkout',
    }
  : {
      direct: 'stage_direct_checkout',
      marketplace: 'stage_marketplace_checkout',
      obn: 'stage_obn_checkout',
    };

const ROKT_CONFIRMATION_IDENTIFIERS: Record<RoktAdsPlatform, string> = IS_PROD
  ? { direct: 'Direct', marketplace: 'Marketplace', obn: 'OBN' }
  : {
      direct: 'stage_direct',
      marketplace: 'stage_marketplace',
      obn: 'stage_obn',
    };

export const getRoktCheckoutIdentifier = (platform: RoktAdsPlatform): string =>
  ROKT_CHECKOUT_IDENTIFIERS[platform];

export const getRoktConfirmationIdentifier = (
  platform: RoktAdsPlatform
): string => ROKT_CONFIRMATION_IDENTIFIERS[platform];
